import React from "react"
import {Slider, Stack, Typography, styled, Box} from "@mui/material"
import InfoIcon from "../../components/general/infoIcon"

export const verticalSliderPrototype = [
    {
        "key": "min",
        "type": "INTEGER",
        "label": "Startwert",
        "size": 6
    },
    {
        "key": "max",
        "type": "INTEGER",
        "label": "Endwert",
        "size": 6
    },
    {
        key: "infotext",
        type: "STRING",
        label: "infotext",
        size: 6,
    },
]

const StyledSlider = styled(Slider)(({theme}) => theme.VERTICALSLIDER.root)

const VerticalSliderWidget = ({widget, value, onValueChange, triggerAction}) => {
    const {min = 0, max = 100, fullHeight} = widget
    const onChange = (event, newValue) => {
        onValueChange(newValue)
    }

    const hasValue = value !== undefined && value !== null && value !== ""
    const numericValue = hasValue ? Number(value) : NaN
    const sliderValue = Number.isFinite(numericValue)
        ? numericValue
        : Number(min)

    return (
        <Stack
            spacing={2}
            alignItems="center"
            sx={fullHeight ? {minHeight: "100%"} : undefined}>
            <Box display="flex" alignItems="center" gap={0.5}>
                <Typography>{widget.text}</Typography>
                {widget.infotext && (
                    <InfoIcon
                        infoText={widget.infotext}
                        color={widget.color}
                    />
                )}
            </Box>
            <Typography>{sliderValue}%</Typography>
            <StyledSlider
                min={Number(min)}
                max={Number(max)}
                orientation="vertical"
                valueLabelDisplay="auto"
                value={sliderValue}
                onChange={onChange}
                sx={fullHeight ? {flex: 1} : undefined}
            />
        </Stack>
    )
}
export default VerticalSliderWidget
